import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const AlertComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, ${color})`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__alert"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M6.0025 2.25179L1.06166 10.5001C0.959795 10.6765 0.905894 10.8765 0.905324 11.0803C0.904753 11.284 0.957533 11.4843 1.05841 11.6613C1.15929 11.8382 1.30475 11.9857 1.48033 12.089C1.6559 12.1923 1.85546 12.2479 2.05916 12.2501H11.9408C12.1445 12.2479 12.3441 12.1923 12.5197 12.089C12.6952 11.9857 12.8407 11.8382 12.9416 11.6613C13.0425 11.4843 13.0952 11.284 13.0947 11.0803C13.0941 10.8765 13.0402 10.6765 12.9383 10.5001L7.9975 2.25179C7.89351 2.08035 7.74709 1.93861 7.57236 1.84024C7.39764 1.74186 7.20051 1.69019 7 1.69019C6.79949 1.69019 6.60236 1.74186 6.42763 1.84024C6.25291 1.93861 6.10649 2.08035 6.0025 2.25179Z"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7 5.25V7.58333" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7 9.91675H7.00583" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const Alert = withIcon(AlertComponent);
